import { PurchaseFlowRoutes, PolicyDownloadRoutes } from '@/shared/types/router.types'

export const DEFAULT_FLOW_STEPS_COUNT = 2
export const DEFAULT_FLOW_CURRENT_STEP = 1

export const PURCHASE_FLOW_ROUTE = [
  PurchaseFlowRoutes.TRAVEL_DATE,
  PurchaseFlowRoutes.HOLDER_INFO,
  PurchaseFlowRoutes.TRAVEL_DURATION,
  PurchaseFlowRoutes.QUOTE,
]

export const POLICY_DOWNLOAD_FLOW_ROUTE = [
  PolicyDownloadRoutes.LIST,
  PolicyDownloadRoutes.ERROR,
  PolicyDownloadRoutes.SUCCESS,
]
